export const login = 'LOGIN'
export const logout = 'LOGOUT'



// WEBPACK FOOTER //
// ./src/store/mutations.js